'use client';

import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
} from 'react';
import useLocalStorage from '@ui/shared/storage/useLocalStorage';

const DefaultPaymentMethodIdContext = createContext<string | null>(null);
const SetDefaultPaymentMethodIdContext = createContext<Dispatch<
  SetStateAction<string | null>
> | null>(null);

export function useDefaultPaymentMethodId() {
  return useContext(DefaultPaymentMethodIdContext);
}

export function useSetDefaultPaymentMethodId() {
  const setDefaultPaymentMethodId = useContext(
    SetDefaultPaymentMethodIdContext,
  );

  if (setDefaultPaymentMethodId === null) {
    throw new Error(
      'useSetDefaultPaymentMethodId must be used within a <DefaultPaymentMethodIdProvider />',
    );
  }

  return setDefaultPaymentMethodId;
}
export default function DefaultPaymentMethodIdProvider({
  children,
}: PropsWithChildren) {
  const [defaultPaymentMethodId, setDefaultPaymentMethodId] = useLocalStorage<
    string | null
  >('defaultPaymentMethodId', null);
  return (
    <DefaultPaymentMethodIdContext.Provider value={defaultPaymentMethodId}>
      <SetDefaultPaymentMethodIdContext.Provider
        value={setDefaultPaymentMethodId}
      >
        {children}
      </SetDefaultPaymentMethodIdContext.Provider>
    </DefaultPaymentMethodIdContext.Provider>
  );
}
